import React from 'react'
import { useSync } from '~/hooks/server/sync'

import { isAdminSpace } from '~/common/define/access'
import { RequestError } from '~/common/define/requestError'
import { ChildProps } from '~/common/define/props'
import { isEmptyModel } from '~/common/utils/model'
import AppLayout from '~/components/layout/AppLayout'
import OrganizationHeader from '~/components/layout/header/OrganizationHeader'
import { OrganizationUserAuthority, userOrganizationAuthority } from '~/common/define/authority'
import ErrorLayoutPage from '~/components/page/error/ErrorLayoutPage'
import ScreenLoading from '~/components/atoms/loading/ScreenLoading'

interface Props extends ChildProps {
  isSetting?: boolean
  denyGuest?: boolean
}

const AppSpaceLayout = ({children, isSetting = false, denyGuest = false}: Props) => {
  const {organization, service, user, error, firstLoading} = useSync()

  if (user && ((isSetting && !isAdminSpace(user, organization, service)) ||
    (denyGuest && userOrganizationAuthority(user, organization) == OrganizationUserAuthority.GUEST))) {
    return <ErrorLayoutPage error={RequestError.NOT_FOUND} />
  }

  return (
    <AppLayout reqError={error}>
      <OrganizationHeader organization={organization} isOrigin={isEmptyModel(service)}/>
      {!firstLoading &&
        <>{children}</>
      }
      {firstLoading &&
        <ScreenLoading/>
      }
    </AppLayout>
  )
}

export default AppSpaceLayout